import { asMultiStyleConfig } from '../../../../utils/theme';
var parts = ['root', 'modalFooter'];
var baseStyle = () => ({
  root: (() => {
    return {
      '.tqc-date-picker': {
        '&__calendar': {
          w: '18.75rem',
          borderRadius: '3px',
          border: '1px solid #B9BEC3',
          boxShadow: '0 0 12px -8px rgba(0,0,0,0.35)'
        },
        '&__header': {
          bg: 'blue.50',
          borderBottom: 'none'
        },
        '&__month-select, &__year-select': {
          '> .tqc-select__control': {
            border: 'none',
            borderRadius: '3xl'
          },
          '.tqc-select__single-value': {
            color: 'blue.275'
          }
        },
        '&__nav-button': {
          bg: 'transparent',
          color: 'blue.275',
          fontSize: '1.25rem'
        },
        '&__day::active': {
          bg: 'blue.250'
        },
        '&__calendar:not(.tqc-date-picker__calendar--mobile) .tqc-date-picker__header .tqc-select__control': {
          maxW: '6.625rem'
        },
        '&__calendar--mobile': {
          width: '100%',
          borderRadius: '0',
          boxShadow: 'none',
          '.tqc-date-picker': {
            '&__header': {
              py: '.875rem'
            },
            '&__nav-button': {
              mx: '1.125rem'
            }
          }
        }
      },
      '.react-datepicker__day--keyboard-selected:focus, .react-datepicker__day:focus': {
        outline: '2px solid #00CAFF',
        boxShadow: '0 0px 3px 3px #4CAAF0'
      }
    };
  })(),
  modalFooter: {
    bg: 'grey.50'
  }
});
export var DatePicker = asMultiStyleConfig({
  parts,
  baseStyle
});